import gql from 'graphql-tag'

export const queryTableFields = table => {
	return {
		query: gql`
			query table_fields($table: String!) {
				__type(name: $table) {
					kind
					name
					fields {
						name
						type {
							ofType {
								kind
							}
						}
					}
				}
			}
		`,
		variables: {
			table: `${table}`
		}
	}
}
